import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SEO = ({ 
  title = 'GHLWA - WhatsApp Integration for GoHighLevel',
  description = 'Professional WhatsApp integration for GoHighLevel. Connect unlimited locations, automate messages, and manage multi-tenant conversations seamlessly.',
  keywords = 'GoHighLevel WhatsApp, GHL WhatsApp integration, WhatsApp Business API, CRM messaging, multi-tenant WhatsApp, automated WhatsApp messages, WhatsApp for agencies',
  canonical = 'https://app.ghlwa.com',
  ogImage = 'https://app.ghlwa.com/ghlwa.png'
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};
